export const ROUTING_NUMBER_PATTERN = /^\d{9}$/;
export const ACCOUNT_NUMBER_PATTERN = /^\d{4,17}$/;
export const ROUTING_NUMBER_LENGTH = 9;
export const ACCOUNT_NUMBER_MAX_LENGTH = 17;
